import axios from 'axios'
import { handleError } from '@/helpers/HandleError';

const NETWORK_ERROR_MESSAGE = 'Strežnik ni odgovoril pravočasno ali ni povezave. Poskusite znova.';

const state = {
	evalvation_filter_options: null,
	evalvation_filter_options_loading: false,
	evalvation_filter_options_error: null,

	evalvation_search_loading: false,
	evalvation_search_error: null,
	evalvation_search_data: null,

	evalvation_analyze_loading: false,
	evalvation_analyze_error: null,
	evalvation_analyze_history: [],
};

const getters = {
	evalvation_filter_options: state => state.evalvation_filter_options,
	evalvation_filter_options_loading: state => state.evalvation_filter_options_loading,
	evalvation_filter_options_error: state => state.evalvation_filter_options_error,

	evalvation_search_loading: state => state.evalvation_search_loading,
	evalvation_search_error: state => state.evalvation_search_error,
	evalvation_search_data: state => state.evalvation_search_data,

	evalvation_analyze_loading: state => state.evalvation_analyze_loading,
	evalvation_analyze_error: state => state.evalvation_analyze_error,
	evalvation_analyze_history: state => state.evalvation_analyze_history,
};

const mutations = {
	setEvalvationFilterOptionsLoading: (state, payload) => {
		state.evalvation_filter_options_loading = payload === true;
	},
	setEvalvationFilterOptions: (state, payload) => {
		state.evalvation_filter_options = payload;
	},
	setEvalvationFilterOptionsError: (state, payload) => {
		state.evalvation_filter_options_error = payload;
	},

	setEvalvationSearchLoading: (state, payload) => {
		state.evalvation_search_loading = payload === true;
	},
	setEvalvationSearchError: (state, payload) => {
		state.evalvation_search_error = payload;
	},
	setEvalvationSearchData: (state, payload) => {
		state.evalvation_search_data = payload;
	},

	setEvalvationAnalyzeLoading: (state, payload) => {
		state.evalvation_analyze_loading = payload === true;
	},
	setEvalvationAnalyzeError: (state, payload) => {
		state.evalvation_analyze_error = payload;
	},
	pushEvalvationAnalyzeHistoryItem: (state, payload) => {
		state.evalvation_analyze_history.push(payload);
	},
	clearEvalvationAnalyzeHistory: (state) => {
		state.evalvation_analyze_history = [];
	},
};

const actions = {
	exportEvalvationAiPlainData: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');
		axios.post('?module=export&action=get_evalvation_ai_plain_data', payload)
			.then(
				res => {
					if (res.data && res.data.success === true) {
						commit('hideModalWorking');
						dispatch('downloadFile', { url: res.data.export_link, filename: res.data.export_filename });
					}
					else {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error });
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	evalvationAiFetchFilterOptions: ({ commit }) => {
		commit('setEvalvationFilterOptionsLoading', true);
		commit('setEvalvationFilterOptionsError', null);

		axios.post('?module=evalvation_ai&action=getAllFields', {})
			.then((res) => {
				if (res.data && res.data.success === true && res.data.data) {
					commit('setEvalvationFilterOptions', res.data.data);
				} else {
					const err = (res.data && res.data.error) ? res.data.error : NETWORK_ERROR_MESSAGE;
					commit('setEvalvationFilterOptions', {});
					commit('setEvalvationFilterOptionsError', err);
				}
			})
			.catch((error) => {
				commit('setEvalvationFilterOptions', {});
				commit('setEvalvationFilterOptionsError', NETWORK_ERROR_MESSAGE);
				handleError(commit, error);
			})
			.finally(() => {
				commit('setEvalvationFilterOptionsLoading', false);
			});
	},

	evalvationAiSearch: ({ commit }, payload) => {
		commit('setEvalvationSearchLoading', true);
		commit('setEvalvationSearchError', null);
		commit('setEvalvationSearchData', null);

		axios.post('?module=evalvation_ai&action=search', payload)
			.then((res) => {
				if (res.data && res.data.success === true) {
					commit('setEvalvationSearchData', res.data.data);
				} else {
					commit('setEvalvationSearchError', (res.data && res.data.error) ? res.data.error : NETWORK_ERROR_MESSAGE);
				}
			})
			.catch((error) => {
				const data = error.response && error.response.data;
				const err = (data && data.error) ? data.error : NETWORK_ERROR_MESSAGE;
				commit('setEvalvationSearchError', err);
			})
			.finally(() => {
				commit('setEvalvationSearchLoading', false);
			});
	},

	evalvationAiAnalyze: ({ commit }, payload) => {
		commit('setEvalvationAnalyzeLoading', true);
		commit('setEvalvationAnalyzeError', null);

		axios.post('?module=evalvation_ai&action=analyze', payload)
			.then((res) => {
				if (res.data && res.data.success === true && res.data.data) {
					const data = res.data.data;
					const instruction = payload && payload.instruction ? payload.instruction : '';
					const model = payload && payload.model ? payload.model : 'gpt-5-mini';
					const result = typeof data.text === 'string'
						? data.text
						: JSON.stringify(data.text != null ? data.text : data, null, 2);

					commit('pushEvalvationAnalyzeHistoryItem', {
						instruction,
						result,
						usage: data.usage || null,
						model
					});
				} else {
					commit('setEvalvationAnalyzeError', (res.data && res.data.error) ? res.data.error : NETWORK_ERROR_MESSAGE);
				}
			})
			.catch((error) => {
				const data = error.response && error.response.data;
				const err = (data && data.error) ? data.error : NETWORK_ERROR_MESSAGE;
				commit('setEvalvationAnalyzeError', err);
			})
			.finally(() => {
				commit('setEvalvationAnalyzeLoading', false);
			});
	},
};

export default{
	state,
	getters,
	actions,
	mutations	
}